import { render } from "./AddEditStuffingComponent.vue?vue&type=template&id=3b470021"
import script from "./AddEditStuffingComponent.vue?vue&type=script&lang=js"
export * from "./AddEditStuffingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__